"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaMobileNavItem = void 0;

require("core-js/modules/es.symbol.description.js");

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _gatsbyPluginImage = require("gatsby-plugin-image");

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _FAMobileIcon = require("./FAMobileIcon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  link: {
    textDecoration: 'none',
    color: theme.workwaveBlue
  }
}));

const FaMobileNavItem = _ref => {
  var _link$teamSoftwareIco;

  let {
    link,
    index,
    close
  } = _ref;
  const classes = useStyles();
  console.log(link.type);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, link.internalLink && link.type !== 'software' || link.type === 'industries' ? /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    className: classes.link,
    to: "/".concat(link.slug.current),
    id: link.navId
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_FAMobileIcon.FAMobileIcon, {
    item: link
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '1.2rem',
      fontWeight: 400,
      fontFamily: '"Poppins", "Roboto", sans-serif'
    }
  }, link.title))) : link.type === 'software' ? /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: "/".concat(link.slug.current),
    style: {
      textDecoration: 'none'
    },
    id: link.navId
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, {
    image: (_link$teamSoftwareIco = link.teamSoftwareIcon) === null || _link$teamSoftwareIco === void 0 ? void 0 : _link$teamSoftwareIco.asset.gatsbyImageData,
    imgStyle: {
      objectFit: 'contain'
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.link
  }, link.mainName), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    className: classes.description
  }, link.description)))) : /*#__PURE__*/_react.default.createElement("a", {
    className: classes.link,
    href: link.slug.current,
    target: "_blank",
    id: link.navId
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: index,
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_FAMobileIcon.FAMobileIcon, {
    item: link
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '1.2rem',
      fontWeight: 400,
      fontFamily: '"Poppins", "Roboto", sans-serif'
    }
  }, link.title))));
};

exports.FaMobileNavItem = FaMobileNavItem;